<template>
  <div class="d-flex justify-space-between align-center w-100" v-if="data">
    <!-- Left side: Reactions -->
    <div
      class="d-flex align-center"
      @click="onShowReactionDialog"
      v-if="data.types"
    >
      <div v-for="(item, index) in data.types" :key="index" class="mr-1">
        <v-img
          :src="
            require(`@/assets/svg/reactions/circle/${item.toLowerCase()}.svg`)
          "
          width="21"
          height="21"
          contain
        />
      </div>
      <span class="url-button ml-2" v-if="data.count">{{ data.count }}</span>
    </div>

    <!-- Right side: Comments -->
    <div class="d-flex align-center" v-if="data.comments" @click="onComment">
      <v-icon small class="mr-1 ms-1"
        >mdi mdi-comment-text-multiple-outline</v-icon
      >
      <span class="url-button comment">
        {{ data.comments === 1 ? "1 comment" : `${data.comments} comments` }}
      </span>
    </div>

    <event-reaction-dialog
      :_id="_id"
      :dialog="reactionDialog"
      :onCloseDialog="onCloseDialog"
      v-if="reactionDialog"
    />
  </div>
</template>

<script>
import EventReactionDialog from "./EventReactionDialog.vue";
export default {
  components: { EventReactionDialog },
  props: {
    data: Object,
    onComment: Function,
    _id: String
  },
  data() {
    return {
      reactionDialog: false
    };
  },
  methods: {
    onShowReactionDialog() {
      this.reactionDialog = true;
    },
    onCloseDialog() {
      this.reactionDialog = false;
    }
  }
};
</script>

<style scoped>
.url-button {
  cursor: pointer;
  font-weight: 500;
}
</style>
